import { handleLoginWithAppsReq } from "../../redux/user-slices/auth.slice"
import { Button, CircularProgress, Icon } from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import { loadFbSdk } from "../../utils/helper"
import Icons from "../../assets/js/Icons"

function FacebookLogin({ stay = null }) {
  const dispatch = useDispatch()
  const { loadings } = useSelector(state => state.authSlice)

  const fetchUserData = () => {
    window.FB.api("/me", { fields: "name,email,picture,gender,birthday" }, response => {
      const formData = {
        signupType: "facebook",
        email: response?.email,
        gender: response?.gender,
        fullName: response?.name,
        image: response?.picture?.data?.url,
      }
      formData.stay = stay
      dispatch(handleLoginWithAppsReq(formData))
    })
  }

  const facebookSDKReq = async () => {
    try {
      await loadFbSdk()
      window.FB.login((response) => {
        if (response.status === "connected") {
          const accessToken = response.authResponse.accessToken
          fetchUserData(accessToken)
        }
      }, { scope: "public_profile,email,user_gender" })
    } catch (err) {
      console.error(err)
    }
  }

  return (
    <Button
      sx={{
        p: "9px 13px",
        width: "100%",
        fontWeight: "400",
        lineHeight: "1.2",
        justifyContent: "center",
        bgcolor: "#3a559f !important"
      }}
      size="small"
      type="button"
      variant="contained"
      onClick={facebookSDKReq}
      startIcon={
        <Icon sx={{ fontSize: "16px !important" }}>
          <Icons.Facebook />
        </Icon>
      }
      endIcon={
        loadings?.loginFB &&
        <CircularProgress
          thickness={6}
          size={22}
          color="text"
        />
      }
    >Login
    </Button>
  )
}

export default FacebookLogin